import { useState } from "react";
import moment from "moment";
import { Box } from "@mui/material";
import { styled } from "@mui/material/styles";
import Modal from "components/atoms/modal";
import { useBrandContext } from "components/context/BrandContext";
import { CloseIcon } from "components/atoms/Icon";
import ScheduleReleaseForm from "./ScheduleReleaseForm";
import ConnectStripe from "./ConnectStripe";

interface IProps {
  open: boolean;
  onClose: () => void;
  handleFieldChange: (event: any, property?: string, propValue?: any) => void;
  editReleaseId: number | undefined;
  data: ReleaseStateType;
  errorState: any;
  currentlyEditingRelease: any;
  isEndDateProvided: boolean;
  magnetAvailableSupply: number;
  handleCreateDraftRelease: () => void;
  handleUpdateRelease: (editReleaseId: number) => void;
  toggleIsEndDateProvided: (func: (prev: boolean) => boolean) => void;
  maxEndTimeForRelease: moment.Moment;
}

const StyledContainer = styled(Box)(() => ({}));

function ReleaseComponent({
  open,
  onClose,
  handleFieldChange,
  editReleaseId,
  data,
  errorState,
  currentlyEditingRelease,
  isEndDateProvided,
  magnetAvailableSupply,
  handleCreateDraftRelease,
  handleUpdateRelease,
  toggleIsEndDateProvided,
  maxEndTimeForRelease,
}: IProps) {
  const { brandDetails } = useBrandContext();
  const [isStartTimeModalOpen, setIsStartTimeModalOpen] = useState(false);
  const [isEndTimeModalOpen, setIsEndTimeModalOpen] = useState(false);
  const closeDatePickers = () => {
    setIsStartTimeModalOpen(false);
    setIsEndTimeModalOpen(false);
  };

  // const isISOString = dayjs(data.startTime.toISOString());
  // const isISOString2 = dayjs(data.startTime);
  // console.log(data.startTime, isISOString, isISOString2);

  // Check to see if the picked date and time.
  // const isSameDate = moment(data?.startTime, "DD-MM-YYYY").diff(moment(data?.endTime, "DD-MM-YYYY"), "days") === 0;

  return (
    <Modal open={open} onClose={onClose} additionalClasses="bg-white bg-opacity-30">
      <StyledContainer
        onClick={closeDatePickers}
        className="relative w-[97vw]  max-w-4xl rounded-2xl bg-primary p-8 text-white shadow-modal"
      >
        <div className="flex justify-between">
          <section className="w-[95%] font-satoshi font-bold sm:text-sm md:text-xl">
            {editReleaseId ? "Update Magnet Release Details" : "Schedule Magnet for Release"}
          </section>
          <span onClick={onClose} className="cursor-pointer">
            <CloseIcon className="h-4 w-4 text-white" />
          </span>
        </div>
        {brandDetails.is_stripe_connected ? (
          <ScheduleReleaseForm
            onClose={onClose}
            data={data}
            maxEndTimeForRelease={maxEndTimeForRelease}
            editReleaseId={editReleaseId}
            errorState={errorState}
            handleCreateDraftRelease={handleCreateDraftRelease}
            handleUpdateRelease={handleUpdateRelease}
            toggleIsEndDateProvided={toggleIsEndDateProvided}
            currentlyEditingRelease={currentlyEditingRelease}
            isEndDateProvided={isEndDateProvided}
            magnetAvailableSupply={magnetAvailableSupply}
            handleFieldChange={handleFieldChange}
            isStartTimeModalOpen={isStartTimeModalOpen}
            isEndTimeModalOpen={isEndTimeModalOpen}
            setIsStartTimeModalOpen={setIsStartTimeModalOpen}
            setIsEndTimeModalOpen={setIsEndTimeModalOpen}
          />
        ) : (
          <ConnectStripe onClose={onClose} />
        )}
      </StyledContainer>
    </Modal>
  );
}

export default ReleaseComponent;
